import * as TYPES from './_store/types';
import { recentListingStatus } from './_config';

function initDataInSoldDetail(store) {
    let { info = {} } = this.soldListingInfo;
    this.setCurrentListingStatus({
        data: 'Sold'
    });
    let params = {
        'sold-date': 180,
        mapSearch: false,
        key: '',
        keywordType: ''
    };
    if (info.city && info.state) {
        params.keywordType = 'city';
        params.key = `${info.city}, ${info.state}`;
    } else if (info.zipCode) {
        params.keywordType = 'zipCode';
        params.key = info.zipCode;
    } else {
        params = {};
        store[TYPES.SET_SHOW_THIS_MODULE](false);
        console.log(
            'Exception: current page is sold-house,but has not city&state or zipCode.'
        );
    }
    store[TYPES.SET_SEARCH_PARAMS](params);
}

export async function asyncData(store) {
    let timeline = false;
    if (!this.soldListingInfo) {
        this.watchConditionNoReq();
    }
    if (this.searchParamsReadyPs) {
        await this.searchParamsReadyPs;
    }
    if (this.soldListingInfo) {
        store[TYPES.SET_SOLD_LISTING_INFO]({
            data: this.soldListingInfo
        });
        initDataInSoldDetail.call(this, store);
    } else {
        try {
            // CHIME-28890
            await store[TYPES.GET_LISTING_STATUS]();
            this.setListingStatus();
            store[TYPES.SET_HAS_FETCH_LISITNG_STATUS](true);
        } catch (e) {
            console.error(e);
        }
        this.watchCondition();
        // fixed CHIME-32323
        if (this.hasFetchListingStatus) {
            timeline = true;
            // this.fetchListingData({ timeline: true });
        }
    }
    this.setFetchStatus();
    if (!this.hasLocation && !this.soldListingInfo) {
        return; 
    }
    let normalizedFilter = this.normalizedFilter;
    if (!this.soldListingInfo) {
        // params.timeline = true
        timeline = true;
    }
    const params = { 
        ... normalizedFilter,
        ...this.listingParams,
    };
    if (timeline) {
        params.timeline = true
    }
    await store[TYPES.GET_LISTING]({ data: params });
    this.setFetchStatus(recentListingStatus.loaded)
}